import PropTypes from "prop-types"
import { map } from "lodash"
import { factorFormatter, assetDollarFormatter } from "helpers/formatters/numbers"

import { FIELDS } from "helpers/simulator"
// factorFormatter is like numberFormatter with the added benefit of displaying - when the value is 0
export default function OriginalRow({ fields, original }) {
  return <>
    <div className="grid-item left-label original no-input">Original</div>
    {map(fields, (field) => <div key={field} className="grid-item original no-input">
      {(field === FIELDS.economicExposure ? assetDollarFormatter : factorFormatter)(original[field])}
    </div>,
    )}
  </>
}

OriginalRow.propTypes = {
  fields: PropTypes.array.isRequired,
  original: PropTypes.shape({
    economicExposure: PropTypes.number,
    positionPercentEquity: PropTypes.number,
    activePercentEquity: PropTypes.number,
  }).isRequired,
}
